import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";

export default class extends ApplicationController {

    static targets = ["hm0_output","hmTabsSection"];
    
    static values = {
        app: String,
        recordid: String
    };
    connect() {

        window.initIntTelSimple = this.initIntTel;
        console.log("Entreprise JS en cours ...");  
        super.connect();
        //has many load
        //contacts
if (this.hasHmTabsSectionTarget) { 
    
        if (
            $("#partial-contact-content").length &&
            $("#partial-contact-content").text().trim() === "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.entreprise_hm_ajax_contact(), 300);
        }
        //missions  active = 1
        if (
            $("#partial-mission-content").length &&
            $("#partial-mission-content").text().trim() === "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.entreprise_hm_ajax_mission(1), 300);
        }

        //missions active = 2
        if (
            $("#partial-mission-inactive-content").length &&
            $("#partial-mission-inactive-content").text().trim() === "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.entreprise_hm_ajax_mission(2), 300);
        }
        //bons_de_commande
        if (
            $("#partial-bons-de-commande-content").length &&
            $("#partial-bons-de-commande-content").text().trim() === "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.entreprise_hm_ajax_bons_de_commande(), 300);
        }
        //contrat
        if (
            $("#partial-contrat-content").length &&
            $("#partial-contrat-content").text().trim() === "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.entreprise_hm_ajax_contrat(), 300);
        }
        //document
        if (
            $("#partial-document-content").length &&
            $("#partial-document-content").text().trim() === "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.entreprise_hm_ajax_document(), 300);
        }
        //facture
        if (
            $("#partial-facture-content").length &&
            $("#partial-facture-content").text().trim() === "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.entreprise_hm_ajax_facture(), 300);
        }
        //factures_sous_traitant
        if (
            $("#partial-facture-sous-traitant-content").length &&
            $("#partial-facture-sous-traitant-content").text().trim() === "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.entreprise_hm_ajax_facture_sous_traitant(), 300);
        }
        //entite
        if (
            $("#partial-entite-content").length &&
            $("#partial-entite-content").text().trim() === "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.entreprise_hm_ajax_entite(), 300);
        }
        //mesures_de_satisfaction
        if (
            $("#partial-mesures-de-satisfaction-content").length &&
            $("#partial-mesures-de-satisfaction-content").text().trim() === "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.entreprise_hm_ajax_mesure_de_satisfaction(), 300);
        }
        //achat_sous_traitant
        if (
            $("#partial-achat-sous-traitant-content").length &&
            $("#partial-achat-sous-traitant-content").text().trim() === "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.entreprise_hm_ajax_achat_sous_traitant(), 300);
        }
        //piste
        if (
            $("#partial-piste-content").length &&
            $("#partial-piste-content").text().trim() === "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.entreprise_hm_ajax_piste(), 300);
        }
        //client/fournisseurs
        if (
            $("#partial-client-content").length &&
            $("#partial-client-content").text().trim() === "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.entreprise_hm_ajax_client(), 300);
        }
        //facture fournisseurs
        if (
            $("#partial-fournisseur-content").length &&
            $("#partial-fournisseur-content").text().trim() === "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.entreprise_hm_ajax_fournisseur(), 300);
        }
        if (
            $("#partial-doublons-content").length &&
            $("#partial-doublons-content").text().trim() === "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.entreprise_hm_ajax_doublons(), 300);
        }
    } 


        if ($("#search").length && $("#quick_sort").length) {
            //on est sur la vue list
            if ($("#activate_em").length) {
                this.show_edition_multiple();
            }
            this.rerender();
            (function ($) {
                $.each(["show", "hide"], function (i, ev) {
                    var el = $.fn[ev];
                    $.fn[ev] = function () {
                        this.trigger(ev);
                        return el.apply(this, arguments);
                    };
                });
            })(jQuery);
            $("#spinner").on("show", function () {
                $("#total_entries").hide();
            });
            $("#spinner").on("hide", function () {
                $("#total_entries").show();
            });


            var targetElement = document.getElementById("mySidebar");
            targetElement.addEventListener("scroll", (event) => {
                var element = document.getElementById("mySidebar");
                document.getElementById("scrollevel").value = element.scrollTop;
            });

            const currentUrl = window.location.href;
            const url = new URL(currentUrl);
            const entrepriseParam = url.searchParams.get("previous_record");

            if (entrepriseParam != null) {
                $("#entreprise_" + entrepriseParam + " td").addClass("highlighted-td");
                $("#entreprise_" + entrepriseParam).get(0).scrollIntoView({ behavior: "smooth", block: "center" });
            }

        }
    }

    entreprise_hm_ajax() {
        if (this.current_app && this.entreprise_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/entreprises/show_ajax_for_hm?entreprise_id=" +
                this.entreprise_id +
                "?parent_id=" +
                this.entreprise_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-content").html("");
                    $("#partial-content").html(text);
                })
            );
        }
    }

    //contact

 

  includeInactive(event) {
    const checked = !!event?.currentTarget?.checked;
    const actif = checked ? 2 : 1;

    const params = new URLSearchParams({
      entreprise_id: String(this.recordidValue),
      vr2: "1",
      actif: String(actif)
    });

    const url = `/${this.appValue}/entreprises/show_ajax_for_hm_contact?${params.toString()}`;

    fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" }})
      .then(r => r.text())
      .then(html => {
        $("#partial-contact-content").html(html);
        $("#partial-entreprises_contacts-badge")
          .html("(" + $(".show_ajax_for_hm_contact >tbody >tr:not(.no_record)").length + ")");
          window.initIntTelSimple();
      })
      .catch(console.error);
  }
  

    entreprise_hm_ajax_contact() {
        if (this.current_app && this.entreprise_id) {
            if (
                $("#partial-contact-content").length &&
                $("#partial-contact-content").text().trim() == "Chargement en cours ..."
            ) {
                let url =
                    window.location.origin +
                    "/" +
                    this.current_app +
                    "/entreprises/show_ajax_for_hm_contact?entreprise_id=" +
                    this.entreprise_id +
                    "&vr2=1";
                fetch(url).then((response) =>
                    response.text().then(function (text) {
                        $("#partial-contact-content").html("");
                        $("#partial-contact-content").html(text);
                        $("#partial-entreprises_contacts-badge").html('(' + $('.show_ajax_for_hm_contact >tbody >tr:not(.no_record)').length + ')');
                        window.initIntTelSimple();
                    })
                );
            }
        }
    }

    //opportunite
    entreprise_hm_ajax_mission(active = 1) {
        var targetPartial = active == 1 ? "#partial-mission-content" : "#partial-mission-inactive-content";
        var targetBadge = active == 1 ? "#partial-entreprises_missions-badge" : "#partial-entreprises_missions_inactive-badge";
    
        if (this.current_app && this.entreprise_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/entreprises/show_ajax_for_hm_mission?entreprise_id=" +
                this.entreprise_id + "&active=" + active +
                "&vr2=1";
    
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $(targetPartial).html("");
                    $(targetPartial).html(text);
    
                    // Correction du sélecteur
                    let rowCount = $(targetPartial).find(".show_ajax_for_hm_missions tbody tr:not(.no_record)").length;
    
                    console.log("Nombre de lignes trouvées :", rowCount); // Vérification
    
                    $(targetBadge).html('(' + rowCount + ')');
                })
            );
        }
    }
    
    //bons de commande
    entreprise_hm_ajax_bons_de_commande() {
        if (this.current_app && this.entreprise_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/entreprises/show_ajax_for_hm_bons_de_commandes?entreprise_id=" +
                this.entreprise_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-bons-de-commande-content").html("");
                    $("#partial-bons-de-commande-content").html(text);
                    $("#partial-entreprises_bons_de_commandes-badge").html('(' + $('.show_ajax_for_hm_bons_de_commandes >tbody >tr:not(.no_record)').length + ')');
                })
            );
        }
    }

    //facture
    entreprise_hm_ajax_facture() {
        if (this.current_app && this.entreprise_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/entreprises/show_ajax_for_hm_factures?entreprise_id=" +
                this.entreprise_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-facture-content").html("");
                    $("#partial-facture-content").html(text);
                    $("#partial-entreprises_factures-badge").html('(' + $('.show_ajax_for_hm_factures >tbody >tr:not(.no_record)').length + ')');
                })
            );
        }
    }

    //entite
    entreprise_hm_ajax_entite() {
        if (this.current_app && this.entreprise_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/entreprises/show_ajax_for_hm_entites?entreprise_id=" +
                this.entreprise_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-entite-content").html("");
                    $("#partial-entite-content").html(text);
                    $("#partial-entreprises_entites_juridiques-badge").html('(' + $('.show_ajax_for_hm_entreprises >tbody >tr:not(.no_record)').length + ')');
                })
            );
        }
    }

    //document
    entreprise_hm_ajax_document() {
        if (this.current_app && this.entreprise_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/entreprises/show_ajax_for_hm_documents?entreprise_id=" +
                this.entreprise_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-document-content").html("");
                    $("#partial-document-content").html(text);
                    $("#partial-entreprises_documents-badge").html('(' + $('.show_ajax_for_hm_documents >tbody >tr:not(.no_record)').length + ')');

                })
            );
        }
    }

    //contrat
    entreprise_hm_ajax_contrat() {
        if (this.current_app && this.entreprise_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/entreprises/show_ajax_for_hm_contrats?entreprise_id=" +
                this.entreprise_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-contrat-content").html("");
                    $("#partial-contrat-content").html(text);
                    $("#partial-entreprises_contrats-badge").html('(' + $('.show_ajax_for_hm_contrats >tbody >tr:not(.no_record)').length + ')');

                })
            );
        }
    }

    //factures-sous-traitant
    entreprise_hm_ajax_facture_sous_traitant() {
        if (this.current_app && this.entreprise_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/entreprises/show_ajax_for_hm_factures_sous_traitants?entreprise_id=" +
                this.entreprise_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-facture-sous-traitant-content").html("");
                    $("#partial-facture-sous-traitant-content").html(text);
                    $("#partial-entreprises_factures_sous_traitants-badge").html('(' + $('.show_ajax_for_hm_factures_sous_traitants >tbody >tr:not(.no_record)').length + ')');
                })
            );
        }
    }

    //mesures-de-satisfaction
    entreprise_hm_ajax_mesure_de_satisfaction() {
        if (this.current_app && this.entreprise_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/entreprises/show_ajax_for_hm_mesures_de_satisfactions?entreprise_id=" +
                this.entreprise_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-mesures-de-satisfaction-content").html("");
                    $("#partial-mesures-de-satisfaction-content").html(text);
                    $("#partial-entreprises_mesures_satisfactions-badge").html('(' + $('.show_ajax_for_hm_mesures_de_satisfactions >tbody >tr:not(.no_record)').length + ')');
                })
            );
        }
    }

    //achat-sous-traitant
    entreprise_hm_ajax_achat_sous_traitant() {
        if (this.current_app && this.entreprise_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/entreprises/show_ajax_for_hm_achats_soustraitants?entreprise_id=" +
                this.entreprise_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-achat-sous-traitant-content").html("");
                    $("#partial-achat-sous-traitant-content").html(text);
                    $("#partial-entreprises_achats_sous_traitants-badge").html('(' + $('.show_ajax_for_hm_achats_soustraitants >tbody >tr:not(.no_record)').length + ')');
                })
            );
        }
    }

    //piste
    entreprise_hm_ajax_piste() {
        if (this.current_app && this.entreprise_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/entreprises/show_ajax_for_hm_pistes?entreprise_id=" +
                this.entreprise_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-piste-content").html("");
                    $("#partial-piste-content").html(text);
                    $("#partial-entreprises_pistes-badge").html('(' + $('.show_ajax_for_hm_pistes >tbody >tr:not(.no_record)').length + ')');
                })
            );
        }
    }

    //client/fournisseur
    entreprise_hm_ajax_client() {
        if (this.current_app && this.entreprise_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/entreprises/show_ajax_for_hm_contrats?entreprise_id=" +
                this.entreprise_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-client-content").html("");
                    $("#partial-client-content").html(text);
                    $("#partial-entreprises_clients-badge").html('(' + $('.show_ajax_for_hm_contrats >tbody >tr:not(.no_record)').length + ')');
                })
            );
        }
    }
    entreprise_hm_ajax_fournisseur() {
        if (this.current_app && this.entreprise_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/entreprises/show_ajax_for_hm_fournisseurs?entreprise_id=" +
                this.entreprise_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-fournisseur-content").html("");
                    $("#partial-fournisseur-content").html(text);
                    $("#partial-entreprises_fournisseurs-badge").html('(' + $('.show_ajax_for_hm_factures_fournisseurs >tbody >tr:not(.no_record)').length + ')');
                })
            );
        }
    }
    entreprise_hm_ajax_doublons() {
        if (this.current_app && this.entreprise_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/entreprises/show_ajax_for_hm_doublons?entreprise_id=" +
                this.entreprise_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-doublons-content").html("");
                    $("#partial-doublons-content").html(text);
                
                         // Correction du sélecteur
                         let rowCount = $("#partial-doublons-content").find(".show_ajax_for_hm_entreprises >tbody >tr:not(.no_record)").length;
    
                         console.log("Nombre de lignes trouvées danas doubons :", rowCount); // Vérification
         
                         $("#partial-entreprises_doublons-badge").html('(' + rowCount + ')');
                })
            );
        }
    }
    show_edition_multiple() {
        if (this.current_app && this.params) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/entreprises/show_ajax_edition_multiple?filtrage=" +
                this.params +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#edition_multiple").html("");
                    $("#edition_multiple").html(text);
                    MicroModal.init();
                })
            );
        }
    }
//  initIntTel() {
//     const inputPhones = document.querySelectorAll(".int-phone");
//     const errorMap = [
//       "Numéro invalide",
//       "Indicatif du pays invalide",
//       "Trop court",
//       "Trop long",
//       "Numéro invalide",
//     ];

//     inputPhones.forEach((phone, index) => {
//       // 👉 Empêche l'initialisation multiple
//       if (phone.dataset.initialized === "true") {
      
//         return;
//       }

//       // ✅ Marque comme initialisé
//       phone.dataset.initialized = "true";

    

//       const iti = intlTelInput(phone, {
//         initialCountry: "fr",
//         formatOnDisplay: true,
//         separateDialCode: true,
//         customPlaceholder: (selectedPlaceholder, selectedCountryData) => {
//           const override = phone.dataset.placeholder;
//           const startDigit = phone.dataset.startDigit;

//           let ph = override ?? selectedPlaceholder;
//           if (!override && selectedCountryData.iso2 === "fr" && startDigit) {
//             ph = selectedPlaceholder.replace(/^6/, startDigit);
//           }
//           return `e.g. ${ph}`;
//         },
//       });

//       const container = phone.parentElement;
//       container.style.position = "relative";

//       const icon = document.createElement("i");
//       icon.className = "fa";
//       icon.style.position = "absolute";
//       icon.style.top = "50%";
//       icon.style.transform = "translateY(-50%)";
//       icon.style.marginLeft = "10px";
//       icon.style.cursor = "pointer";
//       icon.style.fontSize = "1.2em";
//       container.appendChild(icon);

//       const tooltip = document.createElement("div");
//       tooltip.className = "iti-tooltip hide";
//       tooltip.style.position = "absolute";
//       tooltip.style.marginLeft = "10px";
//       tooltip.style.background = "#333";
//       tooltip.style.color = "#fff";
//       tooltip.style.padding = "4px 8px";
//       tooltip.style.borderRadius = "4px";
//       tooltip.style.fontSize = "0.9em";
//       tooltip.style.whiteSpace = "nowrap";
//       tooltip.style.zIndex = "99";
//       container.appendChild(tooltip);

//       const hiddenInput = document.getElementById(`tel_${index}`);

//       const resetUI = () => {
//         phone.classList.remove("error");
//         icon.className = "fa";
//         icon.style.color = "";
//         tooltip.classList.add("hide");
//         if (hiddenInput) hiddenInput.value = "";
//       };

//       const validate = () => {
//         resetUI();
//         if (!phone.value.trim()) return;

//         if (iti.isValidNumber()) {
//           icon.classList.add("fa-check-circle");
//           icon.style.color = "green";
//           tooltip.textContent = "Numéro valide";
//           if (hiddenInput) hiddenInput.value = iti.getNumber();
//         } else {
//           phone.classList.add("error");
//           icon.classList.add("fa-exclamation-circle");
//           icon.style.color = "red";
//           const err = iti.getValidationError();
//           tooltip.textContent = errorMap[err] || "Numéro invalide";
//           if (hiddenInput) hiddenInput.value = "";
//         }
//       };

//       phone.addEventListener("blur", validate);
//       phone.addEventListener("keyup", validate);
//       phone.addEventListener("change", validate);
//       phone.addEventListener("countrychange", resetUI);

//       icon.addEventListener("mouseenter", () => {
//         if (
//           icon.classList.contains("fa-check-circle") ||
//           icon.classList.contains("fa-exclamation-circle")
//         ) {
//           tooltip.classList.remove("hide");
//         }
//       });

//       icon.addEventListener("mouseleave", () => {
//         tooltip.classList.add("hide");
//       });

//       if (phone.value.trim() && iti.isValidNumber()) {
//         if (hiddenInput) hiddenInput.value = iti.getNumber();
//       }
//     });
//   }
    // Fonction pour ajouter la classe  fx-input-date-sidbar-menu aux champs de type date utulisant flatpickr

    get params() {
        return this.data.get("params");
    }

    get entreprise_ids() {
        return this.data.get("entrepriseids");
    }

    get entreprise_id() {
        return this.data.get("entrepriseid");
    }

    get current_app() {
        return this.data.get("app");
    }

    get url_solution() {
        return this.data.get("urlsolution");
    }
}
